// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__u04EG","block":"blog_block__fCzys"};